(function () {
    'use strict';

    angular
        .module('appback')
        .controller('ListasController', ListasController)

    ListasController.$inject = ["socket", "GenerallabService", "PreanaliticaService", "ResultadosService", "ListasService", "$http", "$timeout", "$uibModal", "$log", "$document", "$sce", "$window"];

    function ListasController(socket, GenerallabService, PreanaliticaService, ResultadosService, ListasService, $http, $timeout, $uibModal, $log, $document, $sce, $window) {
        var vm = this;
        if (typeof WebSocketPrinter !== "undefined") {
            vm.printService = new WebSocketPrinter();
        }
        vm.loading = false;
        vm.loadingFull = false;
        vm.showListas = false;
        vm.categoria = "";
        vm.itemsClicked = {};
        vm.listas = [];
        vm.filtros = {};
        vm.mostrar_codigos = true;
        vm.analiticasCategoria = [];
        vm.peticion_idActive = "";
        vm.analiticasTachadas = {};

        vm.generalLab = GenerallabService;

        vm.optionsAnaliticas = {
            ajax: {
                url: "/backend/altcrm/content/select2",
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term, // search term
                        page: params.page,
                        field: 'nombre',
                        per_page: 20,
                    };
                },
                processResults: function (data, params) {
                    params.page = params.page || 1;
                    return {
                        results: data.items,
                        pagination: {
                            more: (params.page * 1) < data.total_count
                        }
                    };
                },
                cache: true
            }
        };



        socket.on('peticion:tachar', function (data) {
            //console.log("peticion:tachar",data);
            $timeout(function () {
                vm.tacharResultados(data);
                /*if(typeof(data)!='undefined'){
                    if(data.datapet.fecha_validacion!=""){
                        vm.tachados[data.id] = true;
                    }else{
                        vm.tachados[data.id] = false;
                    }
                }*/
            })

        });
        vm.listadoRooms = {};
        socket.on('listado:allRooms', function (data) {
            ////console.log("listado:allRooms:listado",data);
            if (typeof (data) != 'undefined') {
                vm.listadoRooms = data;
            }
        });

        vm.inArrayPet = function (id) {
            var res = false;
            ////console.log("tachado busqueda",vm.tachados[id]);
            ////console.log("tachado id",id);
            if (typeof (vm.tachados[id]) != 'undefined' && vm.tachados[id]) {
                res = true;
            }
            return res;
        }

        vm.existHemograma = function (lista) {
            var res = false;
            for (var cont = 0; cont < lista.faltan_validacion.verdes.length && !res; cont++) {
                if (lista.faltan_validacion.verdes[cont].formulario_resultado == "Hemograma") {
                    res = true
                }
            }

            if (!res) {
                for (var cont = 0; cont < lista.faltan_validacion.rojos.length && !res; cont++) {
                    if (lista.faltan_validacion.rojos[cont].formulario_resultado == "Hemograma") {
                        res = true
                    }
                }
            }

            return res;
        }

        vm.loadingCat = {};
        vm.generarLista = function (cat_id) {
            vm.loadingCat[cat_id] = true;
            ListasService.generarLista(vm.laboratorio_id, cat_id, function (data) {
                vm.loadingCat[cat_id] = setInterval(function () {
                    ListasService.getListaById(data.id, function (dataLista) {
                        if (dataLista.lista) {
                            if (typeof (vm.cat_descarga_id) == 'undefined') {
                                vm.cat_descarga_id = {};
                            }
                            vm.cat_descarga_id[cat_id] = dataLista.lista.id;
                            clearInterval(vm.loadingCat[cat_id]);
                            vm.loadingCat[cat_id] = false;
                        }
                    });
                }, 10000);
            });
        }

        vm.timeTen = "";
        vm.currentCat = "";
        vm.categoriaLista = function (cat_id) {
            vm.currentCat = cat_id;
            vm.loading = true;
            ListasService.getListasCategoria(cat_id, function (data) {
                if (vm.loading) {
                    vm.loading = false;
                    if (!angular.equals(vm.listas, data.listas)) {
                        vm.listas = data.listas;
                    }
                    vm.categoria = data.categoria;
                    if (!angular.equals(vm.analiticasCategoria, data.analiticasCategoria)) {
                        vm.analiticasCategoria = data.analiticasCategoria;
                    }
                    vm.showListas = true;
                    vm.timeTen = $timeout(function () {
                        vm.categoriaLista(cat_id);
                    }, 50000);
                }
            });
        }

        vm.clickItem = function ($event) {
            $event.stopPropagation();
            //$event.preventDefault();
            ////console.log(vm.itemsClicked);
        }
        vm.clickedAll = false;
        vm.clickAll = function ($event) {
            $event.stopPropagation();
            vm.clickedAll = !vm.clickedAll;
            for (var cont = 0; cont < vm.peticionesCat.length; cont++) {
                if (typeof (vm.itemsClicked[vm.peticionesCat[cont].id]) == 'undefined') {
                    vm.itemsClicked[vm.peticionesCat[cont].id] = {};
                }
                vm.itemsClicked[vm.peticionesCat[cont].id][vm.peticionesCat[cont].fin_analitica_id] = vm.clickedAll;
            }
            ////console.log(vm.itemsClicked);
        }

        vm.labModal = "";
        vm.cambiarLab = function () {

            vm.labModal = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title-top',
                ariaDescribedBy: 'modal-body-top',
                //windowClass: 'modal-danger',
                backdrop: 'static',
                templateUrl: 'cambiarlab.html',

                //size: 'xlg',
                controller: function ($scope) {
                    $scope.generalLab = vm.generalLab;

                    $scope.code = 0;
                    $scope.msg = "";
                    $scope.laboratorio_id = "";
                    $scope.okForm = function () {
                        PreanaliticaService.cambiarLab(vm.itemsClicked, $scope.laboratorio_id, function (data) {
                            vm.initCategoria(vm.cat_id, vm.page);
                            vm.itemsClicked = {};
                        });

                        vm.labModal.close();
                    }
                    $scope.koForm = function () {
                        vm.labModal.close();
                    }
                }
            });
            ////console.log(vm.itemsClicked);
        }

        vm.labModalID = "";
        vm.cambiarLabIdentificaciones = function () {

            vm.labModalID = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title-top',
                ariaDescribedBy: 'modal-body-top',
                //windowClass: 'modal-danger',
                backdrop: 'static',
                templateUrl: 'cambiarlabidentificacion.html',

                //size: 'xlg',
                controller: function ($scope) {
                    $scope.generalLab = vm.generalLab;

                    $scope.code = 0;
                    $scope.msg = "";
                    $scope.laboratorio_id = "";
                    $scope.okForm = function () {
                        console.log("clicked items", vm.itemsClicked)
                        console.log("laboratorio", $scope.laboratorio_id)
                        PreanaliticaService.cambiarLabIdentificaciones(vm.itemsClicked, $scope.laboratorio_id, function (data) {
                            vm.initCategoria(vm.cat_id, vm.page);
                            vm.itemsClicked = {};
                        });

                        vm.labModalID.close();
                    }
                    $scope.koForm = function () {
                        vm.labModalID.close();
                    }
                }
            });
            ////console.log(vm.itemsClicked);
        }
        vm.patologoModal = "";
        vm.patologo = function () {
            vm.patologoModal = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title-top',
                ariaDescribedBy: 'modal-body-top',
                //windowClass: 'modal-danger',
                backdrop: 'static',
                templateUrl: 'patologo.html',

                //size: 'xlg',
                controller: function ($scope) {
                    $scope.generalLab = vm.generalLab;

                    $scope.code = 0;
                    $scope.msg = "";
                    $scope.validador = "";
                    $scope.okForm = function () {
                        ResultadosService.guardarMultpat(vm.itemsClicked, $scope.validador, function (data) {
                            //$scope.msg = data.msg;
                            //$scope.code = data.code;
                            //lista.externo = result;
                            //item.resultado.id = data.id;
                            //callback(data);
                            vm.initCategoria(vm.cat_id, vm.page)
                        });

                        vm.patologoModal.close();
                    }
                    $scope.koForm = function () {
                        vm.patologoModal.close();
                    }
                }
            });
            ////console.log(vm.itemsClicked);
        }

        vm.filtroAnalitica = function (analitica_id) {
            return function (item) {
                if (!analitica_id || analitica_id.length == 0) {
                    return true;
                }
                return (analitica_id.indexOf("" + item.analitica.id) !== -1)
            }
        }

        vm.vistaRapida = false;
        vm.cambiarVista = function () {
            if (vm.vistaRapida) {
                vm.vistaRapida = false;
                vm.categoriaLista(vm.currentCat);
            } else {
                vm.vistaRapida = true;
                $timeout.cancel(vm.timeTen);
            }
        }

        vm.tacharResultados = function (data) {
            // handler code here }););
            ////console.log("cerrarpopup",data);
            if (typeof (data) != 'undefined') {

                if (data.validar != '') {
                    ////console.log("UND");
                    if (typeof (data.datapet.fecha_validacion) != 'undefined' && data.datapet.fecha_validacion != '') {
                        ////console.log("UND2");
                        vm.tachados[data.id] = true;
                    } else {
                        ////console.log("UND3");
                        vm.tachados[data.id] = false;
                    }
                } else {
                    if (typeof (data.validadas) != 'undefined' && data.validadas.length > 0) {
                        vm.analiticasTachadas[data.id] = {};
                        var validadas_ids = [];
                        for (var cont = 0; cont < data.validadas.length; cont++) {
                            vm.analiticasTachadas[data.id][data.validadas[cont].analitica_id] = true;
                            validadas_ids.push(data.validadas[cont].analitica_id);
                        }
                        /*var res = false;
                        for(var cont=0;cont<vm.peticionesCat.length && !res;cont++){
                            if(vm.peticionesCat[cont].id==data.id){
                                res = true;
                                var resVerd = false;
                                for(var cont2 = 0; cont2 < vm.peticionesCat[cont].faltan_validacion.verdes.length && !resVerd;cont2++){
                                    if(validadas_ids.indexOf(vm.peticionesCat[cont].faltan_validacion.verdes[cont2].id)!==-1){
                                        vm.peticionesCat[cont].faltan_validacion.an_validadas.push(vm.peticionesCat[cont].faltan_validacion.verdes[cont2]);
                                        vm.peticionesCat[cont].faltan_validacion.verdes.splice(cont2,1);
                                        resVerd = true;
                                    }
                                }
                                var resVerd = false;
                                for(var cont2 = 0; cont2 < vm.peticionesCat[cont].faltan_validacion.an_validadas.length && !resVerd;cont2++){
                                    if(validadas_ids.indexOf(vm.peticionesCat[cont].faltan_validacion.an_validadas[cont2].id) == -1){
                                        vm.peticionesCat[cont].faltan_validacion.verdes.push(vm.peticionesCat[cont].faltan_validacion.an_validadas[cont2]);
                                        vm.peticionesCat[cont].faltan_validacion.an_validadas.splice(cont2,1);
                                        resVerd = true;
                                    }
                                }
                            }
                        }*/

                    }
                }
                //console.log("data",data);
                //console.log("tachados",vm.tachados);
            }
        }

        vm.resultadoModal = "";
        vm.fastEdit = false;
        vm.tachados = {};
        vm.resultados = function (peticion_id, analitica_id) {
            vm.peticion_idActive = peticion_id;
            if (vm.fastEdit) {
                //return false;
            }
            vm.loading = true;

            vm.resultadoModal = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title-top',
                ariaDescribedBy: 'modal-body-top',
                windowClass: 'modal-peticion',
                backdrop: 'static',
                templateUrl: '/backend/resultadopeticion/addresultado?peticion_id=' + peticion_id + "&analitica_id=" + analitica_id,
                size: 'full',
                controller: function ($scope) {
                    ////console.log("LISTASCONTROLLERRES");
                    vm.loading = false;
                    ////console.log($scope);
                    ////console.log($scope.$$childTail);
                    $scope.item = {};
                    $scope.peticion_id = peticion_id;
                    $scope.$on("cerrarPopup", function (evt, data) {


                        vm.tacharResultados(data);
                        ////console.log("resultadoTachados",vm.tachados);
                        evt.stopPropagation();

                        vm.resultadoModal.close();
                        $('[data-toggle="tooltip"], .tooltip').tooltip("hide");
                        return false;
                    });
                    $scope.okForm = function () {
                        socket.emit('user:left', peticion_id);
                        //$timeout.cancel(vm.timeTen);
                        vm.resultadoModal.close();
                        $('[data-toggle="tooltip"], .tooltip').tooltip("hide");
                        /*vm.timeTen = $timeout(function(){
                            vm.categoriaLista(vm.currentCat);
                        });*/
                        /*$scope.$broadcast('guardarCambios', {
                          //someProp: 'Sending you some data'
                          callback:function(){
                            vm.resultadoModal.close();
                            return;
                          }
                        });*/

                        // vm.resultadoModal.close();
                    }
                    $scope.koForm = function () {
                        $timeout.cancel(vm.timeTen);
                        /*vm.timeTen = $timeout(function(){
                            vm.categoriaLista(vm.currentCat);
                        });*/
                        vm.resultadoModal.close();
                    }
                }
            });

            vm.resultadoModal.result.then(function () {
                ////console.log("onclose");
                //Get triggers when modal is closed
            }, function (evt) {

                socket.emit('user:left', vm.peticion_idActive);
                $('[data-toggle="tooltip"], .tooltip').tooltip("hide");
                ////console.log("onclose2",data);
                /*$timeout.cancel(vm.timeTen);
                 vm.timeTen = $timeout(function(){
                     vm.categoriaLista(vm.currentCat);
                 });*/
                //gets triggers when modal is dismissed.
            });

        }

        vm.guardarOnChange = function (item) {
            item.loading = true;
            var itemSimple = { peticion_id: item.id, analitica_id: item.fin_analitica_id, resultado: item.resultado };
            ResultadosService.cambiarResultado(itemSimple.peticion_id, false, itemSimple, function (data) {
                item.resultado.id = data.id;
                //callback(data);
                $timeout(function () {
                    item.loading = false;
                })
            })
        }



        vm.printRaw = function (value) {
            vm.printService.submit({
                'type': 'INVOICE',
                'raw_content': value
            });
        };

        vm.imprimirEtiquetaPeticionId = function (peticion_id) {
            ListasService.imprimirEtiquetasPeticionId(peticion_id, function (data) {
                vm.printRaw(data.print);
            });
        }


        vm.resultadosAnaliticas = function (analitica_id) {
            vm.loadingFull = true;

            vm.resultadoModal = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title-top',
                ariaDescribedBy: 'modal-body-top',
                //windowClass: 'modal-danger',
                //backdrop  : 'static',
                templateUrl: '/backend/resultadopeticion/addresultadoanalitica?analitica_id=' + vm.analitica_id.join(","),
                size: 'xlg',
                controller: function ($scope) {
                    vm.loadingFull = false;

                    $scope.item = {};
                    $scope.okForm = function () {
                        $timeout.cancel(vm.timeTen);
                        /*vm.timeTen = $timeout(function(){
                            vm.categoriaLista(vm.currentCat);
                        });*/
                        vm.resultadoModal.close();
                    }
                    $scope.koForm = function () {
                        $timeout.cancel(vm.timeTen);
                        /*vm.timeTen = $timeout(function(){
                            vm.categoriaLista(vm.currentCat);
                        });*/
                        vm.resultadoModal.close();
                    }
                }
            });

            /*vm.resultadoModal.result.then(function(){
             //Get triggers when modal is closed
            }, function(){
                 
             //gets triggers when modal is dismissed.
            });*/

        }

        vm.remove = function (item) {
            var id = vm.listas.indexOf(item);
            if (id != -1) {
                vm.listas.splice(id, 1);
            }
        }
        vm.cancelarVista = function () {
            vm.loading = false;
            vm.showListas = false;
            vm.listas = [];

            $timeout.cancel(vm.timeTen);
        }
        vm.peticiones = [];
        vm.getPeticionesPendientes = function () {
            vm.loading = true;
            ListasService.getPetPendientes(function (data) {
                vm.loading = false;
                vm.peticiones = data.peticiones;
            });

        }

        vm.modalMuestra = "";
        vm.loadingMuestra = false;
        vm.abrirMuestra = function (lista) {
            vm.loadingMuestra = true;
            ListasService.getMuestra(lista.crm_muestra_id, function (data) {
                vm.loadingMuestra = false;
                vm.modalMuestra = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title-top',
                    ariaDescribedBy: 'modal-body-top',
                    templateUrl: 'modalMuestra.html',
                    size: 'lg',
                    controller: function ($scope) {


                        $scope.muestra = {};
                        $scope.muestra = data.muestra;


                        $scope.okForm = function () {
                            vm.modalMuestra.close();
                        }
                        $scope.koForm = function () {
                            vm.modalMuestra.close();
                        }
                    }
                });
            });
        }
        vm.peticionesCat = [];
        vm.analiticas = [];
        vm.items = 0;
        vm.maxPages = 0;
        vm.page = 0;
        vm.initCategoria = function (cat_id, page, init) {
            if (typeof (page) != 'undefined') {
                vm.page = page;
            }
            if (init) {
                vm.buscarFiltros();
            }
            vm.loading = true;
            ListasService.getListaCatnew(cat_id, vm.page, vm.filtros, function (data) {

                if (!init) {
                    var queryParams = new URLSearchParams(window.location.search);

                    // Set new or modify existing parameter value. 
                    queryParams.set("page", vm.page);
                    if (vm.filtros.lims_id) {
                        queryParams.set("lims_id", vm.filtros.lims_id);
                    } else {
                        queryParams.delete("lims_id");
                    }
                    if (vm.filtros.tipomuestra) {
                        queryParams.set("tipomuestra", vm.filtros.tipomuestra);
                    } else {
                        queryParams.delete("tipomuestra");
                    }
                    if (vm.filtros.analiticas) {
                        queryParams.set("analiticas", vm.filtros.analiticas.join(","));
                    } else {
                        queryParams.delete("analiticas");
                    }
                    if (vm.filtros.orden) {
                        queryParams.set("orden", vm.filtros.orden);
                    } else {
                        queryParams.delete("orden");
                    }
                    // Replace current querystring with the new one.
                    history.replaceState(null, null, "?" + queryParams.toString());
                }
                vm.peticionesCat = data.peticionesPendientes;
                vm.items = data.items;
                vm.maxPages = data.maxPage;
                vm.loading = false;
                ////console.log(data);
                socket.emit("listado:allRooms");

            });
        }

        vm.stopProp = function ($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }

        vm.externModal = "";
        vm.extern = function ($event, lista) {
            $event.stopPropagation();
            $event.preventDefault();

            vm.externModal = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title-top',
                ariaDescribedBy: 'modal-body-top',
                //windowClass: 'modal-danger',
                backdrop: 'static',
                templateUrl: 'extern.html',
                size: 'sm',
                //size: 'xlg',
                controller: function ($scope) {
                    $scope.generalLab = vm.generalLab;
                    vm.loading = false;
                    $scope.lista = lista;
                    $scope.code = 0;
                    $scope.msg = "";
                    $scope.okForm = function () {
                        var result = { empresaexterna_id: $scope.empresaexterna_id, analitica_id: lista.fin_analitica_id, id: lista.id }
                        ResultadosService.guardarExtern(result, function (data) {
                            $scope.msg = data.msg;
                            $scope.code = data.code;
                            lista.externo = result;
                            //item.resultado.id = data.id;
                            //callback(data);
                        });

                        //vm.externModal.close();
                    }
                    $scope.koForm = function () {
                        vm.externModal.close();
                    }
                }
            });
            ////console.log(lista);
            return false;
        }

        vm.externModalSingleIdentif = "";
        vm.singleId = {};
        vm.externSingleIdentif = function ($event, lista) {
            $event.stopPropagation();
            $event.preventDefault();

            vm.externModalSingleIdentif = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title-top',
                ariaDescribedBy: 'modal-body-top',
                //windowClass: 'modal-danger',
                backdrop: 'static',
                templateUrl: 'cambiarlabidentificacion.html',
                size: 'sm',
                //size: 'xlg',
                controller: function ($scope) {
                    $scope.generalLab = vm.generalLab;
                    vm.loading = false;
                    $scope.lista = lista;
                    $scope.code = 0;
                    $scope.msg = "";
                    $scope.laboratorio_id = "";
                    $scope.okForm = function () {
                        vm.singleId[lista.id] = {};
                        vm.singleId[lista.id][lista.fin_analitica_id] = true;
                        console.log("singleId", vm.singleId);
                        PreanaliticaService.cambiarLabIdentificaciones(vm.singleId, $scope.laboratorio_id, function (data) {
                            lista.externoId = data;
                            vm.singleId = {};

                        });
                        vm.externModalSingleIdentif.close();

                    }
                    $scope.koForm = function () {
                        vm.externModalSingleIdentif.close();
                    }
                }
            });
            return false;
        }





        vm.getaccionesByPeticionId = function ($event, id) {
            ResultadosService.getAccionesByPet(id, function (data) {
                vm.getAccionesById($event, data.acciones, id);
            })

        }

        vm.getAccionesById = function ($event, acciones, id) {
            //console.log("event",$event);
            if (angular.isDefined($event)) {
                $event.stopPropagation();
                $event.preventDefault();
            }
            vm.popupAcciones = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title-top',
                ariaDescribedBy: 'modal-body-top',
                //windowClass: 'modal-danger',
                //backdrop  : 'static',
                templateUrl: '/backend/resultadopeticion/templateresultados?name=acciones.twig',
                size: 'lg',
                controller: function ($scope) {
                    //console.log("id",id);
                    $scope.generalLab = vm.generalLab;
                    $scope.generalLab.acciones = acciones;
                    $scope.peticion_id = id;
                    //$scope.resultados = acciones;

                    $scope.okForm = function () {
                        vm.popupAcciones.close();
                    }
                    $scope.koForm = function () {
                        vm.popupAcciones.close();
                    }
                }
            });
        }

        vm.initEmpresa = function (analiticas, page) {
            if (typeof (page) != 'undefined') {
                vm.page = page;
            }
            vm.loading = true;
            ListasService.getListaEmpresa(vm.page, vm.filtros, function (data) {
                vm.peticionesCat = data.peticionesPendientes;
                vm.items = data.items;
                vm.maxPages = data.maxPage;
                vm.loading = false;
                ////console.log(data);
            });
        }

        vm.buscarFiltros = function () {
            var url_string = window.location.href
            var url = new URL(url_string);
            if (url.searchParams.get("lims_id")) {
                vm.filtros.lims_id = url.searchParams.get("lims_id");
            }

            if (url.searchParams.get("analiticas")) {
                ////console.log(url.searchParams.get("analiticas"));    
                vm.filtros.analiticas = url.searchParams.get("analiticas").split(",");
                ////console.log(url.searchParams.get("analiticas").split(","));    
                ////console.log(vm.filtros.analiticas);    
            }

            if (url.searchParams.get("orden")) {
                vm.filtros.orden = url.searchParams.get("orden");
            }

            if (url.searchParams.get("tipomuestra")) {
                vm.filtros.tipomuestra = url.searchParams.get("tipomuestra").split(",");
            }

            if (url.searchParams.get("page")) {
                vm.page = parseInt(url.searchParams.get("page"));
            }
            ////console.log(vm.filtros);

        }

        vm.getListadoUsers = function (id) {
            var nombres = [];
            ////console.log("fueraf for");
            if (typeof (vm.listadoRooms[id]) != 'undefined') {
                ////console.log("fuera for");
                for (var cont = 0; cont < vm.listadoRooms[id].length; cont++) {
                    ////console.log("for",vm.listadoRooms[id][cont]);
                    nombres.push(vm.listadoRooms[id][cont].name);
                }
            }
            return nombres.join(", ");
        }
        vm.initPendientes = function (analiticas, page, init) {
            if (typeof (page) != 'undefined') {
                vm.page = page;
            }
            if (init) {
                vm.buscarFiltros();
            }

            vm.loading = true;
            ListasService.getListaPendientes(vm.page, vm.analiticas, vm.filtros, function (data) {

                // Construct URLSearchParams object instance from current URL querystring.
                if (!init) {
                    var queryParams = new URLSearchParams(window.location.search);

                    // Set new or modify existing parameter value. 
                    queryParams.set("page", vm.page);
                    if (vm.filtros.lims_id) {
                        queryParams.set("lims_id", vm.filtros.lims_id);
                    } else {
                        queryParams.delete("lims_id");
                    }
                    if (vm.filtros.analiticas) {
                        queryParams.set("analiticas", vm.filtros.analiticas.join(","));
                    } else {
                        queryParams.delete("analiticas");
                    }
                    if (vm.filtros.tipomuestra) {
                        queryParams.set("tipomuestra", vm.filtros.tipomuestra.join(","));
                    } else {
                        queryParams.delete("tipomuestra");
                    }
                    if (vm.filtros.orden) {
                        queryParams.set("orden", vm.filtros.orden);
                    } else {
                        queryParams.delete("orden");
                    }
                    // Replace current querystring with the new one.
                    history.replaceState(null, null, "?" + queryParams.toString());
                }



                vm.peticionesCat = data.peticionesPendientes;
                vm.items = data.items;
                vm.maxPages = data.maxPage;
                vm.loading = false;
                ////console.log(data);
                socket.emit("listado:allRooms");
            });
        }



        vm.pendientes = [];
        vm.categorias = [];
        vm.analiticas = [];
        vm.initListatotal = function (cat_id) {
            ListasService.listaTotal(cat_id, function (data) {
                vm.pendientes = data.pendientes;
                vm.categorias = data.categorias;
                vm.analiticas = data.analiticas;
                ////console.log(vm.categorias);
            });
        }

        vm.sorterFunc = function (analit) {
            return parseInt(analit.dias);
        };

        vm.analiticasfueraplazo = [];
        vm.fueraPlazo = function () {
            ListasService.fueraPlazo(function (data) {
                vm.analiticasfueraplazo = data.finales;
            });
        }

        vm.modalAmpliacion = "";
        vm.aceptarAmpliacion = function (peticion_id) {
            PreanaliticaService.getPeticion(peticion_id, function (data) {

                vm.modalAmpliacion = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title-top',
                    ariaDescribedBy: 'modal-body-top',
                    //windowClass: 'modal-danger',
                    backdrop: 'static',
                    templateUrl: 'infolab.html',

                    //size: 'xlg',
                    controller: function ($scope) {
                        $scope.generalLab = vm.generalLab;
                        $scope.currentPeticion = data.peticionCurrent;

                        $scope.cambiarANO = function (index, pre) {
                            $scope.currentPeticion.preanalitica_lab.analiticasPueden.splice(index, 1);
                            $scope.currentPeticion.preanalitica_lab.analiticasNoPueden.push(pre);

                        }

                        $scope.cambiarASI = function (index, pre) {
                            $scope.currentPeticion.preanalitica_lab.analiticasNoPueden.splice(index, 1);
                            $scope.currentPeticion.preanalitica_lab.analiticasPueden.push(pre);

                        }

                        $scope.okForm = function () {
                            PreanaliticaService.saveAmpliacion($scope.currentPeticion, function (data) {
                                vm.modalAmpliacion.close();
                                location.reload();

                            });
                        }
                        $scope.koForm = function () {
                            vm.modalAmpliacion.close();
                        }
                    }
                });
            });
            ////console.log("TEST");
        }
    }

})();